<template>
  <div class="page-tab account-change-container" style="height: 540px">
    <SchemaTablePage
      ref="tablePageRef"
      :form-props="{ labelPosition: 'left' }"
      layout-mode="dialog"
      :immediate="false"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #changeAmount="{ row }">
        <span :class="row.changeAmount.startsWith('-') ? 'amount-negative' : 'amount-positive'">
          {{ row.changeAmount }}
        </span>
      </template>
      <template #remark="{ row }">
        {{ row.remark }}
      </template>
    </SchemaTablePage>
  </div>
</template>

<script>
import SchemaTablePage from '@/components/SchemaTablePage'
import { getAccountChange } from '@/api/user'
import { CHANGE_TYPE_OPTIONS } from '@/const'
import { formatCurrencyString } from '@/pages/common/utils'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
export default {
  name: 'AccountChange',
  components: { SchemaTablePage },
  filters: {
    formatCurrencyString,
  },
  props: {
    resetKey: {
      type: Number,
      default: 0,
    },
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    uid: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultQuery: {
        changeType: '',
        changeDateRange: [],
      },
      searchSchema: [
        {
          prop: 'changeType',
          label: '账变类型',
          component: 'select',
          componentProps: { clearable: true },
          options: CHANGE_TYPE_OPTIONS,
        },
        {
          prop: 'changeDateRange',
          label: '账变时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { resizable: false, prop: 'orderNo', label: '订单号', minWidth: 200 },
        { resizable: false, prop: 'changeType', label: '账变类型', minWidth: 100 },
        { resizable: false, prop: 'changeAmount', label: '账变金额', minWidth: 100, slot: 'changeAmount' },
        { resizable: false, prop: 'beforeAmount', label: '账变前金额', minWidth: 100 },
        { resizable: false, prop: 'afterAmount', label: '账变后金额', minWidth: 100 },
        { resizable: false, prop: 'changeTime', label: '账变时间', minWidth: 140 },
        { resizable: false, prop: 'remark', label: '备注', minWidth: 200, slot: 'remark' },
      ],
    }
  },
  computed: {
    request() {
      return params => getAccountChange(params)
    },
    buildParams() {
      return ({ query, page, limit }) => {
        const changeDateRange = query?.changeDateRange || []
        const start_at = changeDateRange?.[0] ? toUnixSeconds(changeDateRange[0]) : 0
        const end_at = changeDateRange?.[1] ? toUnixSeconds(changeDateRange[1]) : 0
        return {
          change_type: query?.changeType === '' || query?.changeType == null ? 0 : query?.changeType,
          start_at,
          end_at,
          page,
          page_size: limit,
          uid: this.uid,
        }
      }
    },
    parseResult() {
      return response => {
        if (response && response.code === 0 && response.data) {
          const list = response.data.list || []
          return {
            list: list.map(record => {
              const changeTypeLabel =
                CHANGE_TYPE_OPTIONS.find(item => {
                  if (record.change_type >= 1 && record.change_type <= 100) return item.value === 1
                  return item.value === record.change_type
                })?.label || ''
              return {
                orderNo: `TXN${record.trade_no}`,
                changeType: changeTypeLabel,
                changeAmount: `${record.change >= 0 ? '+' : ''}${centsToYuan(record.change)}`,
                beforeAmount: centsToYuan(record.before),
                afterAmount: centsToYuan(record.after),
                changeTime: formatTimestamp(record.created_at),
                remark: record.reason,
              }
            }),
            total: response.data.total || 0,
          }
        }
        this.$message.error(response?.msg || response?.message || '加载账变记录失败')
        return { list: [], total: 0 }
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.tablePageRef?.reload?.())
  },
  watch: {
    resetKey() {
      this.$nextTick(() => {
        this.$refs.tablePageRef?.reset?.()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.account-change-container {
  padding: 0;
  height: 550px;
}

.filter-section {
  margin-bottom: 20px;

  ::v-deep {
    .el-form--label-right {
      .el-form-item {
        display: flex;
        justify-items: center;
        width: 100%;
      }

      .el-form-item__label {
        flex: none;
        padding-right: 8px;
      }

      .el-form-item__content {
        flex: auto;
        min-width: 0;

        .el-select {
          width: 100%;
        }
      }
    }
  }
}

.amount-positive {
  color: #f56c6c;
  font-weight: 500;
}

.amount-negative {
  color: #e6a23c;
  font-weight: 500;
}
</style>
